module.exports = [
    {label: "实线",value: "solid"},
    {label: "虚线",value: "dashed"},
    {label: "点线",value: "dotted"},
    {label: "双实线",value: "double"},
    {label: "雕刻效果",value: "groove"},
    {label: "浮雕效果",value: "ridge"},
    {label: "陷入效果",value: "inset"},
    {label: "突出效果",value: "outset"},
]

